import { VStack } from '@chakra-ui/react'
import { UserExperiencesEditor } from '@src/components/sco/Account/UserExperiencesEditor'
import { UserSkillsEditor } from '@src/components/sco/Account/UserSkillsEditor'
import {
  MatchingSignupNav,
  matchingSignupNavItems,
} from '@src/components/sco/Matching/Layout/MatchingSignupNav'
import { OnboardingLayout } from '@src/components/sco/Onboarding/Layout/OnboardingLayout'
import { OnboardingMainPanel } from '@src/components/sco/Onboarding/Layout/OnboardingMainPanel'
import React, { useState } from 'react'

export default function Page() {
  const [refetchTrigger, setRefetchTrigger] = useState(0)
  const [submitTrigger, setSubmitTrigger] = useState(0)

  return (
    <OnboardingLayout
      navItems={matchingSignupNavItems}
      navPanel={<MatchingSignupNav />}
      mainPanel={
        <OnboardingMainPanel onNext={() => setSubmitTrigger(x => x + 1)}>
          <VStack
            align={'center'}
            justify={'center'}
            marginX={'auto'}
            maxWidth={'container.lg'}
            minHeight={'85vh'}
            padding={'2em 1em'}
            width={'full'}
          >
            <UserSkillsEditor
              refetchTrigger={refetchTrigger}
              onDetectionCompleted={() => setRefetchTrigger(prev => prev + 1)}
            />
            <UserExperiencesEditor
              refetchTrigger={refetchTrigger}
              onDetectionCompleted={() => setRefetchTrigger(prev => prev + 1)}
            />
          </VStack>
        </OnboardingMainPanel>
      }
    />
  )
}
